import React, { useState, useEffect } from 'react';

import { Form, Input, Button, Card } from 'antd';
import { Link } from 'react-router-dom';

import { ArrowLeftOutlined } from '@ant-design/icons';

import { toast } from 'react-toastify';
import { CardHeader } from '@material-ui/core';
import api from '~/services/api';
import history from '~/services/history';
import { Container } from './styles';

export default function DepartmentNew(params) {
  const [departmentInfo, setDepartmentInfo] = useState({});

  const [form] = Form.useForm();

  const [updateFlag, setUpdateFlag] = useState(false);

  const [size, setSize] = useState();
  const [page, setPage] = useState();
  const [query, setQuery] = useState();

  const layout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 14,
    },
  };
  /* eslint-disable no-template-curly-in-string */

  useEffect(() => {
    async function loadDepartment() {
      const location = new URLSearchParams(params.location.search);
      const department_name = location.get('name');
      const pageSize = location.get('size');
      const pages = location.get('page');
      const searchQuery = location.get('searchQuery');
      if (department_name) {
        const department_info = await api.get(`departments/${department_name}`);
        const department = {
          name: department_info.data.name,
        };
        form.setFieldsValue(department);
        setDepartmentInfo(department_info.data);
        setUpdateFlag(true);
        setSize(pageSize);
        setPage(pages);
        setQuery(searchQuery === 'undefined' ? undefined : searchQuery);
      } else {
        setSize(25);
        setPage(1);
      }
    }
    loadDepartment();
  }, []); // eslint-disable-line

  const onFinish = async values => {
    const newDepartment = {
      name: values.name,
      shipstation_department_id: values.shipstationDepartmentId,
    };

    try {
      if (updateFlag) {
        await api.put(`departments/${departmentInfo.name}`, newDepartment);
        toast.success('department Updated.');
      } else {
        await api.post('departments', newDepartment);
        toast.success('New Department created.');
      }
      history.push('/departments');
    } catch {
      toast.error('Error loading Department. Contact RBMS administrator.');
    }
  };

  return (
    <Container>
      <Card>
        <Form {...layout} form={form} name="nest-messages" onFinish={onFinish}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Link to={() => (query === undefined ? `/departments?size=${size}&page=${page}` : `/departments?searchQuery=${query}&size=${size}&page=${page}`)}>
              <Button variant="contained" type="primary" icon={<ArrowLeftOutlined />}>
                Back
              </Button>
            </Link>
            {updateFlag === true ? <CardHeader subheader={`${departmentInfo.name}`} title="Update Department" /> : <CardHeader title="New Department" />}
            <div />
          </div>
          <Card title="Department Information" headStyle={{ backgroundColor: 'whitesmoke' }}>
            <Form.Item
              name="name"
              label="Name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              {updateFlag === true ? (
                <Input allowClear placeholder="Department's Name" disabled="true" />
              ) : (
                <Input allowClear placeholder="Department's Name" />
              )}
            </Form.Item>
          </Card>
          <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 4 }}>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Container>
  );
}
